import * as React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import getClientEnvironment from '../../getClientEnvironment';
import {
    ConfirmDisconnectProps,
    withConfirmDisconnect
} from '../Login/withDisconnect';
import { LoggedInUserProps, withLoggedInUser } from '../Login/withLoggedInUser';
import './index.scss';

const config = getClientEnvironment();

const DisconnectLink = withConfirmDisconnect(
    ({
        confirmDisconnect,
        children
    }: ConfirmDisconnectProps & { children?: React.ReactNode }) => (
        <a onClick={confirmDisconnect} href="#">
            {children}
        </a>
    )
);

const PrivacyInfo = ({ loggedInUser }: LoggedInUserProps) => (
    <Card className="info-card">
        <CardBody>
            <CardTitle>Privacy info</CardTitle>
            <ul>
                <li>
                    Connecting with Strava will allow {config.TITLE + ' '}
                    to download and display your Strava activities.
                </li>
                <li>
                    Only you can view your activities. We will not share your
                    data with anyone else or use it for any other purpose.
                </li>
                <li>
                    We will store your Strava details and activities on our
                    server for no more than two weeks after you use the app.
                </li>
                <li>
                    You can{' '}
                    {loggedInUser ? (
                        <DisconnectLink>
                            disconnect the app from Strava
                        </DisconnectLink>
                    ) : (
                        'disconnect the app from Strava'
                    )}{' '}
                    at any time. We will delete all your data from our server
                    immediately.
                </li>
            </ul>
        </CardBody>
    </Card>
);

export default withLoggedInUser(PrivacyInfo);



// WEBPACK FOOTER //
// ./src/client/components/About/PrivacyInfo.tsx